module.exports = __webpack_public_path__ + "img/nbv-review-gray.8b6698fb.svg";